import React from "react";
import { Helmet } from "react-helmet";

const Head = () => {
  return (
    <Helmet>
      <title>Marketplace</title>
    </Helmet>
  );
};
export default Head;
